import React, { FC } from 'react';
import { useTheme } from '@mui/material';

interface Props {
  className?: string;
  size?: number;
}

export const ServerError500Icon: FC<Props> = ({ className, size = 345 }) => {
  const theme = useTheme();

  return (
    <svg
      className={className}
      width="600"
      height={size}
      viewBox="0 0 500 345"
      fill={theme.palette.primary.main}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M144.265 210.258C202.263 210.258 249.28 163.19 249.28 105.129C249.28 47.0677 202.263 0 144.265 0C86.2664 0 39.2495 47.0677 39.2495 105.129C39.2495 163.19 86.2664 210.258 144.265 210.258Z"
        fill="#F2F2F2"
      />
      <path d="M0 25.2419C0 63.492 23.9701 94.4434 53.5926 94.4434L0 25.2419Z" fill="#2F2E41" />
      <path d="M53.5928 94.4434C53.5928 55.7636 80.3421 24.4644 113.399 24.4644L53.5928 94.4434Z" />
      <path d="M19.4175 28.7094C19.4175 65.0428 34.7028 94.4434 53.5925 94.4434L19.4175 28.7094Z" />
      <path d="M53.5928 94.4434C53.5928 45.0192 84.5108 5.02576 122.72 5.02576L53.5928 94.4434Z" fill="#2F2E41" />
      <path
        d="M42.3184 94.9313C42.3184 94.9313 49.9187 94.6969 52.2092 93.0641C54.4998 91.4313 63.9004 89.4816 64.4686 92.1003C65.0369 94.719 75.8905 105.125 67.3098 105.194C58.7291 105.263 47.372 103.856 45.0859 102.462C42.7997 101.068 42.3184 94.9313 42.3184 94.9313Z"
        fill="#A8A8A8"
      />
      <path
        opacity="0.2"
        d="M67.4629 104.282C58.8822 104.352 47.5252 102.944 45.239 101.55C43.498 100.488 42.8042 96.679 42.5721 94.9214C42.4113 94.9283 42.3184 94.9313 42.3184 94.9313C42.3184 94.9313 42.7997 101.068 45.0859 102.462C47.372 103.856 58.7291 105.263 67.3098 105.194C69.7867 105.174 70.6423 104.292 70.5953 102.985C70.2512 103.774 69.3065 104.267 67.4629 104.282Z"
        fill="black"
      />
      <path
        d="M97.9201 222.073C148.839 222.073 190.117 216.452 190.117 209.517C190.117 202.583 148.839 196.961 97.9201 196.961C47.0014 196.961 5.72363 202.583 5.72363 209.517C5.72363 216.452 47.0014 222.073 97.9201 222.073Z"
        fill="#3F3D56"
      />
      <path
        opacity="0.1"
        d="M97.9202 220.059C140.67 220.059 175.326 215.339 175.326 209.517C175.326 203.695 140.67 198.975 97.9202 198.975C55.1703 198.975 20.5146 203.695 20.5146 209.517C20.5146 215.339 55.1703 220.059 97.9202 220.059Z"
        fill="black"
      />
      <path
        d="M412.473 345C489.531 345 552 336.492 552 325.998C552 315.503 489.531 306.996 412.473 306.996C335.414 306.996 272.945 315.503 272.945 325.998C272.945 336.492 335.414 345 412.473 345Z"
        fill="#3F3D56"
      />
      <path
        d="M153.139 330.009C199.429 330.009 236.954 324.899 236.954 318.594C236.954 312.29 199.429 307.18 153.139 307.18C106.849 307.18 69.3242 312.29 69.3242 318.594C69.3242 324.899 106.849 330.009 153.139 330.009Z"
        fill="#3F3D56"
      />
      <path
        d="M228.08 308.97C272.452 320.322 357.746 294.163 367.114 264.549"
        stroke="#2F2E41"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M152.646 127.833C152.646 127.833 216.74 110.064 220.685 167.318C224.629 224.571 167.93 240.858 212.303 252.21"
        stroke="#2F2E41"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M90.7231 265.183C90.7231 265.183 109.987 259.842 111.172 277.05C112.358 294.258 95.3168 299.153 108.653 302.565"
        stroke="#2F2E41"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M383.924 277.994L380.04 302.818C380.04 302.818 360.92 312.987 374.364 313.286C387.808 313.585 451.145 313.286 451.145 313.286C451.145 313.286 463.394 313.286 443.975 302.519L440.091 276.499L383.924 277.994Z"
        fill="#2F2E41"
      />
      <path
        opacity="0.1"
        d="M371.659 313.016C374.713 310.297 380.04 307.463 380.04 307.463L383.924 282.639L440.091 282.692L443.975 307.164C448.503 309.674 451.308 311.599 452.95 313.076C455.444 312.506 458.169 310.389 443.975 302.519L440.091 276.499L383.924 277.994L380.04 302.818C380.04 302.818 363.973 311.364 371.659 313.016Z"
        fill="black"
      />
      <path
        d="M529.336 104.975H294.082C289.168 104.975 285.185 108.963 285.185 113.882V272.527C285.185 277.446 289.168 281.433 294.082 281.433H529.336C534.25 281.433 538.233 277.446 538.233 272.527V113.882C538.233 108.963 534.25 104.975 529.336 104.975Z"
        fill="#2F2E41"
      />
      <path d="M529.718 114.396H293.699V246.59H529.718V114.396Z" fill="#3F3D56" />
      <path
        d="M411.709 111.704C412.534 111.704 413.202 111.035 413.202 110.209C413.202 109.383 412.534 108.714 411.709 108.714C410.884 108.714 410.215 109.383 410.215 110.209C410.215 111.035 410.884 111.704 411.709 111.704Z"
        fill="#F2F2F2"
      />
      <path
        d="M538.233 257.058V272.527C538.234 273.696 538.004 274.855 537.556 275.935C537.109 277.016 536.454 277.998 535.628 278.825C534.802 279.652 533.821 280.308 532.741 280.756C531.662 281.203 530.505 281.434 529.336 281.433H294.082C292.913 281.434 291.756 281.203 290.677 280.756C289.597 280.308 288.616 279.652 287.79 278.825C286.964 277.998 286.309 277.016 285.862 275.935C285.414 274.855 285.184 273.696 285.185 272.527V257.058H538.233Z"
        fill="#2F2E41"
      />
      <path
        d="M477.734 329.436V332.427H317.002V330.034L317.223 329.436L321.185 318.669H474.448L477.734 329.436Z"
        fill="#2F2E41"
      />
      <path
        d="M539.589 326.508C539.297 327.761 538.191 329.083 535.694 330.333C526.731 334.82 508.506 329.137 508.506 329.137C508.506 329.137 494.465 326.744 494.465 320.464C494.859 320.193 495.27 319.949 495.696 319.731C499.464 317.735 511.958 312.81 534.111 319.939C535.743 320.452 537.201 321.409 538.322 322.702C539.22 323.754 539.924 325.088 539.589 326.508Z"
        fill="#2F2E41"
      />
      <path
        opacity="0.1"
        d="M539.589 326.508C528.619 330.716 518.841 331.03 508.805 324.053C503.744 320.535 499.146 319.665 495.696 319.731C499.464 317.735 511.958 312.81 534.112 319.939C535.744 320.452 537.201 321.408 538.323 322.702C539.22 323.754 539.924 325.088 539.589 326.508Z"
        fill="black"
      />
      <path
        d="M525.835 324.053C527.98 324.053 529.719 323.517 529.719 322.856C529.719 322.196 527.98 321.66 525.835 321.66C523.69 321.66 521.951 322.196 521.951 322.856C521.951 323.517 523.69 324.053 525.835 324.053Z"
        fill="#F2F2F2"
      />
      <path
        d="M411.709 275.003C414.844 275.003 417.385 272.459 417.385 269.321C417.385 266.182 414.844 263.638 411.709 263.638C408.574 263.638 406.032 266.182 406.032 269.321C406.032 272.459 408.574 275.003 411.709 275.003Z"
        fill="#F2F2F2"
      />
      <path opacity="0.1" d="M477.734 329.436V332.427H317.002V330.034L317.223 329.436H477.734Z" fill="black" />
      <path d="M156.097 78.4764H53.5474V197.918H156.097V78.4764Z" fill="#2F2E41" />
      <path d="M166.451 66.6309H43.1938V109.077H166.451V66.6309Z" fill="#3F3D56" />
      <path d="M166.451 116.974H43.1938V159.421H166.451V116.974Z" fill="#3F3D56" />
      <path d="M166.451 167.318H43.1938V209.764H166.451V167.318Z" fill="#3F3D56" />
      <path opacity="0.4" d="M141.8 74.0344H133.911V81.9314H141.8V74.0344Z" />
      <path opacity="0.8" d="M153.139 74.0344H145.251V81.9314H153.139V74.0344Z" />
      <path d="M164.479 74.0344H156.59V81.9314H164.479V74.0344Z" />
      <path opacity="0.4" d="M141.8 123.884H133.911V131.781H141.8V123.884Z" />
      <path opacity="0.8" d="M153.139 123.884H145.251V131.781H153.139V123.884Z" />
      <path d="M164.479 123.884H156.59V131.781H164.479V123.884Z" />
      <path opacity="0.4" d="M141.8 173.734H133.911V181.631H141.8V173.734Z" />
      <path opacity="0.8" d="M153.139 173.734H145.251V181.631H153.139V173.734Z" />
      <path d="M164.479 173.734H156.59V181.631H164.479V173.734Z" />
      <path
        d="M156.098 304.528C177.609 304.528 195.047 287.071 195.047 265.536C195.047 244.002 177.609 226.545 156.098 226.545C134.587 226.545 117.148 244.002 117.148 265.536C117.148 287.071 134.587 304.528 156.098 304.528Z"
        fill="#2F2E41"
      />
      <path d="M150.181 296.137H138.349V317.36H150.181V296.137Z" fill="#2F2E41" />
      <path d="M173.846 296.137H162.014V317.36H173.846V296.137Z" fill="#2F2E41" />
      <path
        d="M148.209 321.309C153.655 321.309 158.07 319.652 158.07 317.607C158.07 315.563 153.655 313.906 148.209 313.906C142.763 313.906 138.349 315.563 138.349 317.607C138.349 319.652 142.763 321.309 148.209 321.309Z"
        fill="#2F2E41"
      />
      <path
        d="M171.874 320.815C177.32 320.815 181.735 319.158 181.735 317.114C181.735 315.069 177.32 313.412 171.874 313.412C166.428 313.412 162.014 315.069 162.014 317.114C162.014 319.158 166.428 320.815 171.874 320.815Z"
        fill="#2F2E41"
      />
      <path
        d="M157.084 268.991C164.436 268.991 170.396 263.025 170.396 255.665C170.396 248.305 164.436 242.339 157.084 242.339C149.732 242.339 143.772 248.305 143.772 255.665C143.772 263.025 149.732 268.991 157.084 268.991Z"
        fill="white"
      />
      <path
        d="M157.084 260.107C159.534 260.107 161.521 258.119 161.521 255.665C161.521 253.212 159.534 251.223 157.084 251.223C154.633 251.223 152.646 253.212 152.646 255.665C152.646 258.119 154.633 260.107 157.084 260.107Z"
        fill="#3F3D56"
      />
      <path d="M118.316 229.276C115.171 215.176 125.224 200.928 140.77 197.453C156.316 193.978 171.469 202.591 174.614 216.691C177.759 230.791 167.455 235.991 151.909 239.466C136.363 242.942 121.461 243.375 118.316 229.276Z" />
      <path
        d="M192.628 257.76C202.516 253.523 209.455 247.569 208.126 244.462C206.797 241.354 197.705 242.27 187.817 246.507C177.929 250.743 170.99 256.697 172.319 259.804C173.647 262.912 182.74 261.996 192.628 257.76Z"
        fill="#2F2E41"
      />
      <path
        d="M119.66 283.919C129.548 279.682 136.486 273.728 135.158 270.621C133.829 267.513 124.736 268.429 114.849 272.665C104.961 276.902 98.0219 282.856 99.3504 285.963C100.679 289.071 109.772 288.155 119.66 283.919Z"
        fill="#2F2E41"
      />
      <path
        d="M178.777 276.888C178.777 280.705 168.962 288.24 158.07 288.24C147.178 288.24 136.87 281.198 136.87 277.382C136.87 273.566 147.178 274.421 158.07 274.421C168.962 274.421 178.777 273.072 178.777 276.888Z"
        fill="white"
      />
    </svg>
  );
};
